var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header w3-card-4"},[_c('span',{staticClass:"header-text"},[_vm._v(_vm._s(_vm.headerText))])])}
var staticRenderFns = []

export { render, staticRenderFns }